import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { navItems } from './sidebar-data';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppHorizontalNavItemComponent } from './nav-item/nav-item.component';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { Roles } from '../../shared/Enums';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-horizontal-sidebar',
  standalone: true,
  imports: [AppHorizontalNavItemComponent, NgIf, NgForOf, CommonModule],
  templateUrl: './sidebar.component.html',
})
export class AppHorizontalSidebarComponent implements OnInit {
  navItems = navItems;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  userRole: string = ""
  user: User

  constructor(
    public navService: NavService,
    public router: Router,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private userService: UserService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.userRole = this.userService.user.role

    if (this.userRole === Roles.ROLE_DISTRIBUTOR) {
      this.navItems = [
        {
          displayName: 'HOME',
          iconName: 'home',
          route: '/home',
        },
        {
          displayName: 'ORDER.MANUFACTURING.TITLE',
          iconName: 'list',
          route: '/manufacturing',
        },
        {
          displayName: 'CLIENTS',
          iconName: 'users',
          route: '/clients',
        },
        {
          displayName: 'FILLABLE_PDF',
          iconName: 'file-type-pdf',
          route: '/fillable-pdfs',
        },
        {
          displayName: 'ANALYTICS',
          iconName: 'chart-bar',
          route: '/analytics',
        },
        {
          displayName: 'CUSTOM_FORMS',
          iconName: 'forms',
          route: '/custom-forms',
        },
        {
          displayName: 'WEBHOOKS',
          iconName: 'webhook',
          route: '/webhooks',
        },
        // {
        //   displayName: 'Orders',
        //   iconName: 'shopping-bag',
        //   route: '/orders',
        // },
      ];
    }

    if (this.userRole === Roles.ROLE_CUSTOMER) {
      this.navItems = [
        {
          displayName: 'HOME',
          iconName: 'home',
          route: '/home',
        },
        {
          displayName: 'CLINICS',
          iconName: 'building',
          route: '/clinics',
        },
        {
          displayName: 'USERS',
          iconName: 'users',
          route: '/users',
        },
        {
          displayName: 'CUSTOM_FORMS',
          iconName: 'forms',
          route: '/custom-forms',
        },
      ];
    }

    if (this.userRole === Roles.ROLE_CLINIC) {
      this.navItems = [
        // {
        //   navCap: 'Home',
        // },
        {
          displayName: 'HOME',
          iconName: 'home',
          route: '/home',
        },
        // {
        //   displayName: 'Orders',
        //   iconName: 'shopping-bag',
        //   route: '/orders',
        // }
      ];
    }

    if (window.location.pathname === '/') {
      this.router.navigate(['/home']);
    }
  }
}
